import { render } from "./duplicate.dialog.vue?vue&type=template&id=2e934942"
import script from "./duplicate.dialog.vue?vue&type=script&lang=js"
export * from "./duplicate.dialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__